export const features = [
  {
    id: 'f1',
    icon: 'ri-rocket-2-line',
    title: '智能匹配引擎',
    description: '基于AI算法的智能匹配引擎，能够精准分析用户需求并快速匹配最合适的资源与服务，大幅提升效率与满意度。',
  },
  {
    id: 'f2',
    icon: 'ri-shield-check-line',
    title: '安全可靠保障',
    description: '采用多层安全防护体系，所有数据传输全程加密，用户隐私得到严格保护，确保每一次使用都安心无忧。',
  },
  {
    id: 'f3',
    icon: 'ri-bar-chart-grouped-line',
    title: '数据分析洞察',
    description: '提供全方位的数据统计与分析功能，帮助用户实时掌握关键指标，用数据驱动决策，让每一步都走得更稳。',
  },
  {
    id: 'f4',
    icon: 'ri-team-line',
    title: '协同办公生态',
    description: '打通团队协作全链路，支持多人在线实时协作，文件共享、任务分配、进度追踪一站式搞定。',
  },
  {
    id: 'f5',
    icon: 'ri-smartphone-line',
    title: '多终端无缝同步',
    description: '支持PC端、移动端、平板等多设备无缝切换，所有数据实时云端同步，随时随地都能高效工作。',
  },
  {
    id: 'f6',
    icon: 'ri-customer-service-2-line',
    title: '7×24小时专属客服',
    description: '专业的客户服务团队全天候在线，无论遇到任何问题都能获得及时响应和专业解答。',
  },
];

export const reviews = [
  {
    id: 'r1',
    name: '张伟',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20business%20portrait%20of%20a%20man%20in%20his%2030s%2C%20clean%20background%2C%20warm%20lighting%2C%20friendly%20expression&width=200&height=200&seq=avatar-01&orientation=squarish',
    role: '创业者',
    rating: 5,
    content: '自从使用了91牛平台，我们团队的工作效率提升了至少40%。资源匹配非常精准，界面也很友好，强烈推荐给所有中小企业！',
  },
  {
    id: 'r2',
    name: '李婷',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20business%20portrait%20of%20a%20woman%20in%20her%2020s%2C%20clean%20background%2C%20warm%20lighting%2C%20confident%20smile&width=200&height=200&seq=avatar-02&orientation=squarish',
    role: '自由职业者',
    rating: 5,
    content: '作为一个自由职业者，91牛帮我找到了很多优质的项目资源。平台的筛选和匹配功能真的非常强大，省去了我大量寻找客户的时间。',
  },
  {
    id: 'r3',
    name: '王浩然',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20business%20portrait%20of%20a%20man%20in%20his%2040s%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20approachable&width=200&height=200&seq=avatar-03&orientation=squarish',
    role: '企业管理者',
    rating: 5,
    content: '91牛的数据分析功能是我们做决策的重要参考。界面直观，数据可视化做得很好，团队里的每个人都能快速上手。',
  },
  {
    id: 'r4',
    name: '陈思雨',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20business%20portrait%20of%20a%20young%20woman%20in%20her%20late%2020s%2C%20clean%20background%2C%20warm%20tone%2C%20natural%20smile&width=200&height=200&seq=avatar-04&orientation=squarish',
    role: '自媒体运营',
    rating: 5,
    content: '用91牛半年了，从内容规划到资源对接都非常顺畅。平台的社区氛围也特别好，认识了很多志同道合的朋友。',
  },
  {
    id: 'r5',
    name: '刘建国',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20business%20portrait%20of%20a%20middle-aged%20man%2C%20clean%20background%2C%20warm%20studio%20lighting%2C%20experienced%20professional&width=200&height=200&seq=avatar-05&orientation=squarish',
    role: '技术顾问',
    rating: 5,
    content: '作为技术出身的人，我对平台的稳定性和安全性要求很高。91牛在这方面做得非常出色，响应速度和服务质量都超出预期。',
  },
];

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'tutorial', name: '使用教程', icon: 'ri-guide-line' },
  { slug: 'feature', name: '功能介绍', icon: 'ri-star-line' },
  { slug: 'activity', name: '最新活动', icon: 'ri-fire-line' },
  { slug: 'case', name: '用户案例', icon: 'ri-user-heart-line' },
  { slug: 'news', name: '平台动态', icon: 'ri-newspaper-line' },
];

export const articles = [
  {
    id: 'a1',
    category: 'tutorial',
    title: '91牛新手指南：5分钟快速上手',
    excerpt: '刚注册91牛不知道从何开始？这篇新手指南将带你快速了解平台的核心功能，让你在5分钟内就能熟练使用。',
    content: `<p>欢迎加入91牛大家庭！本文将帮助你快速了解91牛平台的核心功能，让你在最短时间内上手使用。</p>
<h2>第一步：完成个人资料</h2>
<p>注册成功后，建议你先完善个人资料。点击右上角头像进入个人中心，填写你的基本信息、技能标签和偏好设置。完善的资料有助于平台为你精准匹配资源。</p>
<h2>第二步：探索核心功能</h2>
<p>91牛平台主要有六大核心功能模块：智能匹配引擎、资源库、数据分析、团队协作、消息中心和项目管理。建议你先从智能匹配开始，输入你的需求，系统会自动推荐最合适的资源。</p>
<h2>第三步：加入社区</h2>
<p>在社区板块，你可以与其他用户交流经验、分享心得。参与社区讨论不仅能学到更多技巧，还有机会获得平台专属福利。</p>
<h2>使用小贴士</h2>
<ul><li>定期更新你的偏好设置，让匹配更精准</li><li>善用快捷键提升操作效率</li><li>关注平台公告，不错过任何新功能和活动</li></ul>`,
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20workspace%20with%20laptop%20showing%20dashboard%20interface%2C%20warm%20natural%20light%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20creative%20atmosphere&width=1200&height=600&seq=article-a1&orientation=landscape',
    author: '91牛运营团队',
    date: '2026-07-28',
    readTime: '5分钟',
  },
  {
    id: 'a2',
    category: 'feature',
    title: '智能匹配引擎深度解析：如何帮你找到最佳资源',
    excerpt: '智能匹配是91牛最核心的功能之一。本文将深入解析智能匹配引擎的工作原理，以及如何最大化利用这一功能。',
    content: `<p>智能匹配引擎是91牛平台最引以为傲的核心技术。它基于先进的AI算法，能够深入理解用户需求并精准匹配合适的资源与服务。</p>
<h2>技术原理</h2>
<p>智能匹配引擎采用多维度特征提取和语义理解技术，从用户的偏好设置、历史行为、评价反馈等多个维度进行综合分析，构建精准的用户画像和资源画像。</p>
<h2>匹配流程</h2>
<p>当你输入需求后，系统会在毫秒级时间内完成以下步骤：需求解析 → 特征提取 → 候选召回 → 精准排序 → 结果输出。整个过程高效流畅。</p>
<h2>优化建议</h2>
<ul><li>提供更详细的需求描述可以显著提高匹配准确率</li><li>定期更新技能标签和偏好设置</li><li>对匹配结果进行反馈评分，帮助系统持续学习优化</li></ul>`,
    coverImage: 'https://readdy.ai/api/search-image?query=futuristic%20AI%20matching%20engine%20concept%20with%20abstract%20data%20nodes%20and%20connections%2C%20warm%20orange%20and%20gold%20tones%2C%20minimalist%20design%2C%20clean%20geometric%20patterns&width=1200&height=600&seq=article-a2&orientation=landscape',
    author: '91牛技术团队',
    date: '2026-07-25',
    readTime: '8分钟',
  },
  {
    id: 'a3',
    category: 'tutorial',
    title: '如何利用数据分析功能提升工作效率',
    excerpt: '数据驱动是现代工作的核心方法论。本文将教你如何利用91牛的数据分析功能，从数据中发现价值，优化工作流程。',
    content: `<p>在信息爆炸的时代，数据分析能力已成为核心竞争力的重要组成部分。91牛平台内置了强大的数据分析功能，帮助你从海量数据中提炼有价值的信息。</p>
<h2>数据面板概览</h2>
<p>登录后在首页即可看到数据概览面板，展示关键指标如：工作进度、资源使用率、团队效率等核心数据。</p>
<h2>自定义报表</h2>
<p>你可以根据需要创建自定义报表，选择关注的数据维度和时间范围，系统会自动生成可视化图表。</p>
<h2>数据导出与分析</h2>
<p>支持将数据导出为Excel、CSV等常见格式，方便进行进一步的深度分析或与团队分享。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20data%20analytics%20dashboard%20with%20colorful%20charts%20and%20graphs%2C%20warm%20lighting%2C%20clean%20minimalist%20design%2C%20professional%20workspace&width=1200&height=600&seq=article-a3&orientation=landscape',
    author: '91牛产品团队',
    date: '2026-07-20',
    readTime: '6分钟',
  },
  {
    id: 'a4',
    category: 'activity',
    title: '91牛夏日狂欢季：多重福利等你来拿',
    excerpt: '炎炎夏日，91牛推出多重福利活动！新用户注册即享大礼包，老用户邀请好友赢好礼，精彩不容错过！',
    content: `<p>这个夏天，91牛为你准备了一系列精彩活动！无论你是新朋友还是老用户，都有专属福利等着你。</p>
<h2>新用户专享</h2>
<p>即日起至8月31日，新注册用户可领取价值299元的新手大礼包，包含：会员体验7天、专属客服通道、优先匹配特权。</p>
<h2>邀请有礼</h2>
<p>邀请好友注册91牛，双方均可获得积分奖励。积分可兑换会员时长、增值服务等实用好礼。</p>
<h2>社区互动赢大奖</h2>
<p>参与社区话题讨论，分享你的使用心得，即有机会获得91牛限量周边和年度会员等超级大奖！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=vibrant%20summer%20celebration%20concept%20with%20warm%20sunlight%2C%20golden%20confetti%2C%20festive%20atmosphere%2C%20bright%20and%20energetic%2C%20clean%20composition&width=1200&height=600&seq=article-a4&orientation=landscape',
    author: '91牛运营团队',
    date: '2026-08-01',
    readTime: '3分钟',
  },
  {
    id: 'a5',
    category: 'case',
    title: '用户故事：从零到月入过万，她用91牛实现了自由职业梦想',
    excerpt: '90后设计师小李分享了她如何借助91牛平台从零起步，逐步建立起稳定的自由职业事业。',
    content: `<p>本期我们邀请到了91牛的资深用户——自由设计师小李，分享她的成长故事。</p>
<h2>起步阶段</h2>
<p>去年3月，刚刚离职的小李抱着试试看的心态注册了91牛。通过平台的智能匹配功能，她很快就接到了第一个设计项目。</p>
<h2>快速成长</h2>
<p>随着项目经验的积累和平台评价的提升，小李的匹配优先级不断提高，接到的项目质量也越来越好。</p>
<h2>实现目标</h2>
<p>如今，小李已经成为91牛平台上的明星设计师，月均收入稳定过万，实现了自由职业的梦想。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=young%20Chinese%20woman%20designer%20working%20happily%20at%20a%20cozy%20home%20office%2C%20natural%20light%20streaming%20through%20window%2C%20minimalist%20decor%2C%20warm%20and%20inspiring%20atmosphere&width=1200&height=600&seq=article-a5&orientation=landscape',
    author: '91牛内容团队',
    date: '2026-07-15',
    readTime: '10分钟',
  },
  {
    id: 'a6',
    category: 'news',
    title: '91牛V3.0版本发布：全新界面，更强性能',
    excerpt: '经过数月的研发和测试，91牛V3.0正式上线！带来了全新的视觉设计和多项性能优化。',
    content: `<p>我们很高兴地宣布，91牛V3.0版本正式发布！本次更新带来了全方位的体验升级。</p>
<h2>视觉焕新</h2>
<p>全新的UI设计语言，更加简洁直观的操作界面，让每一次使用都赏心悦目。</p>
<h2>性能提升</h2>
<p>页面加载速度提升60%，搜索响应速度提升45%，整体流畅度显著提高。</p>
<h2>新功能上线</h2>
<p>新增批量操作、智能提醒、夜间模式等多项用户期待已久的功能。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20software%20version%203%20launch%20concept%2C%20sleek%20abstract%20design%20with%20warm%20orange%20accents%2C%20clean%20gradient%20background%2C%20minimalist%20tech%20aesthetic&width=1200&height=600&seq=article-a6&orientation=landscape',
    author: '91牛技术团队',
    date: '2026-07-10',
    readTime: '4分钟',
  },
  {
    id: 'a7',
    category: 'tutorial',
    title: '团队协作功能完全指南',
    excerpt: '了解如何充分利用91牛的团队协作功能，让团队工作更高效、沟通更顺畅。',
    content: `<p>91牛的团队协作功能是提升团队效率的利器。本文将详细介绍如何高效使用这一功能。</p>
<h2>创建团队空间</h2>
<p>在个人中心点击"创建团队"，输入团队名称和基本信息即可创建专属团队空间。</p>
<h2>成员管理</h2>
<p>支持通过邮箱或手机号邀请成员，可设置不同权限级别，灵活管理团队结构。</p>
<h2>协作工具</h2>
<p>内置任务分配、文件共享、实时讨论、进度追踪等功能，覆盖团队协作的各个场景。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=diverse%20team%20collaborating%20around%20a%20modern%20table%20with%20laptops%2C%20warm%20office%20lighting%2C%20energetic%20atmosphere%2C%20creative%20workspace&width=1200&height=600&seq=article-a7&orientation=landscape',
    author: '91牛产品团队',
    date: '2026-07-05',
    readTime: '7分钟',
  },
  {
    id: 'a8',
    category: 'feature',
    title: '安全防护体系全面解读',
    excerpt: '数据安全是91牛最重视的方面之一。本文详细介绍了91牛的多层安全防护体系。',
    content: `<p>在数字化时代，数据安全至关重要。91牛从平台建立之初就将安全放在首位。</p>
<h2>传输加密</h2>
<p>所有数据传输均采用业界领先的TLS 1.3加密协议，确保数据在传输过程中不被窃取。</p>
<h2>存储安全</h2>
<p>用户数据采用AES-256加密存储，分布式架构确保数据高可用性和容灾能力。</p>
<h2>权限管理</h2>
<p>细粒度的权限控制系统，确保每个用户只能访问被授权的数据和功能。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=cybersecurity%20shield%20concept%20with%20abstract%20lock%20and%20data%20protection%20symbols%2C%20warm%20orange%20glow%2C%20minimalist%20design%2C%20professional%20tech%20aesthetic&width=1200&height=600&seq=article-a8&orientation=landscape',
    author: '91牛安全团队',
    date: '2026-06-28',
    readTime: '5分钟',
  },
];

export const faqs = [
  {
    id: 'q1',
    question: '91牛平台是免费的吗？',
    answer: '91牛提供免费基础版和付费高级版两种选择。基础版已包含大部分核心功能，可满足日常使用需求。高级版则提供更多增值服务，如高级数据分析、优先匹配、专属客服等。新用户注册即可获得7天高级版体验。',
  },
  {
    id: 'q2',
    question: '如何注册91牛账号？',
    answer: '注册非常简单！点击页面右上角的"免费注册"按钮，输入手机号或邮箱，设置密码，完成验证后即可成功注册。整个注册过程只需1分钟。你也可以使用微信或支付宝账号一键登录。',
  },
  {
    id: 'q3',
    question: '91牛的数据安全如何保障？',
    answer: '我们采用行业内最高等级的安全标准，包括TLS 1.3传输加密、AES-256存储加密、分布式灾备架构以及严格的权限管理。同时我们已通过ISO 27001信息安全管理体系认证，确保您的数据安全无忧。',
  },
  {
    id: 'q4',
    question: '可以在手机上使用91牛吗？',
    answer: '当然可以！91牛支持多终端无缝使用，包括PC网页端、iOS和Android移动端App。所有数据实时云端同步，让你随时随地都能高效工作。',
  },
  {
    id: 'q5',
    question: '如果遇到使用问题怎么办？',
    answer: '我们提供7×24小时全天候客服支持。你可以通过在线客服、官方邮箱support@qx-ly.cn或客服热线400-XXX-XXXX联系我们。此外，平台内置的帮助中心和社区论坛也能帮你快速解决常见问题。',
  },
  {
    id: 'q6',
    question: '如何邀请团队成员加入？',
    answer: '在团队空间中点击"邀请成员"，通过邮箱或手机号发送邀请链接即可。团队成员接受邀请后会自动加入团队空间。团队管理员可以灵活设置每个成员的权限级别。',
  },
  {
    id: 'q7',
    question: '91牛支持哪些支付方式？',
    answer: '我们支持微信支付、支付宝、银联卡等主流支付方式。升级会员时选择你偏好的方式即可完成支付，整个过程安全便捷。',
  },
];